import React, { Component } from 'react';
import {
    getDataByUniqueModalName,
    getIsOpenByUniqueModalName
} from './modalViewState';
import { toggleModal } from './modalActions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import './Modal.scss';

export class Modal extends Component {
    static propTypes = {
        className: PropTypes.string,
        children: PropTypes.any,
        data: PropTypes.any,
        isOpen: PropTypes.bool,
        onClose: PropTypes.func,
        onOpen: PropTypes.func,
        onToggleModal: PropTypes.func,
        title: PropTypes.string,
        uniqueModalName: PropTypes.string.isRequired,
        forceOpen: PropTypes.bool,
        captureError: PropTypes.bool,
        resetAmountOnClose: PropTypes.func

    };

    constructor(props) {
        super(props);

        this.state = {
            animateOpen: false
        };

        this.handleToggleOpen = this.handleToggleOpen.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isOpen')) {
            this.setState({ isOpen: this.props.isOpen });
            setTimeout(() => {
                this.setState({ animateOpen: this.props.isOpen });
            }, 0);

            if (this.props.isOpen) {
                if (this.props.onOpen) {
                    this.props.onOpen();
                }
            } else {
                if (this.props.forceOpen && !this.props.data) {
                    //force modal to stay open
                    return;
                }

                if (this.props.onClose) {
                    this.props.onClose();
                }
            }
        }
    }

    handleToggleOpen() {
        if (this.props.forceOpen) return;

        if (this.props.captureError && this.state.animateOpen) {
            this.props.onToggleModal(this.props.uniqueModalName, this.props.data);
            this.props.resetAmountOnClose();
        } else {
            this.props.onToggleModal(this.props.uniqueModalName, this.props.data);
        }
    }

    render() {
        const containerClassNames = classNames('emvio-modal', {
            'animate-open': this.state.animateOpen,
            'open': this.state.isOpen
        });

        if (this.state.isOpen) {
            return (
                <div className={containerClassNames}>
                    <div className="background" onClick={this.handleToggleOpen} />
                    <div className={classNames('modal', this.props.className)}>
                        <div className="modal-header">
                            {this.props.title}
                            {this.props.forceOpen ? null : <span className="icon-close" onClick={this.handleToggleOpen} />}
                        </div>
                        <div className="modal-content">
                            {this.props.children}
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        isOpen: getIsOpenByUniqueModalName(state, ownProps.uniqueModalName),
        data: getDataByUniqueModalName(state, ownProps.uniqueModalName)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onToggleModal: (uniqueModalName, data) => dispatch(toggleModal(uniqueModalName, data))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
